import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EventAwareCheckIn from './components/EventAwareCheckIn';
import SurveyPage from './components/SurveyPage';
import EventTitle from './components/EventTitle';
import PoweredBy from './components/PoweredBy';
import ThemeProvider from './components/ThemeProvider';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app">
          <EventTitle />
          
          <main className="check-in-container">
            <Routes>
              {/* Survey routes */}
              <Route path="/survey/:surveyId" element={<SurveyPage />} />
              
              {/* Default check-in route */}
                <Route path="/" element={<EventAwareCheckIn />} />
              
              {/* Event-specific routes */}
              <Route path="/:eventPath" element={<EventAwareCheckIn />} />
              <Route path="/:eventPath/checkin" element={<EventAwareCheckIn />} />
                {/* Keep register path but render EventAware so tabs remain visible */}
                <Route path="/:eventPath/register" element={<EventAwareCheckIn />} />
              <Route path="/:eventPath/program" element={<EventAwareCheckIn />} />
            </Routes>
          </main>
          
          <footer style={{ 
            color: 'white', 
            textAlign: 'center', 
            marginTop: '2rem',
            marginBottom: '50px',
            opacity: 0.8,
            fontSize: '0.9rem'
          }}>
            <p>Need help? Please ask our event staff</p>
          </footer>
          
          <PoweredBy />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
